import type { CSSProperties, FC } from "react";
import React from "react";
import classNames from "classnames";
import LogoLoader from "@/components/LogoLoader";
import css from "./SuspenseLoader.module.css";

type SuspenseLoaderProps = {
  height: number;
  size?: "sm" | "md" | "lg";
  label?: string;
  speed?: "slow" | "medium" | "fast";
  className?: string;
  style?: CSSProperties;
};

const SuspenseLoader: FC<SuspenseLoaderProps> = ({
  height,
  size = "md",
  label = "Loading",
  speed = "medium",
  className,
  style,
}) => {
  return (
    <div
      className={classNames(css.container, className)}
      style={{ height, ...style }}
    >
      <div className={css.centered}>
        <LogoLoader size={size} speed={speed} label={label} />
      </div>
    </div>
  );
};

export default SuspenseLoader;
